import { Component } from 'react';

class AdditionalBox extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <div className="table-additional-view">
                    <div className="table-additional-view-btns">
                        <div className="table-additional-view-btn-groups">
                            <button
                                className={`${
                                    (!this.props.view || this.props.view === 1) && 'active'
                                }`}
                                onClick={() => this.props.onChange(1)}
                            >
                                {t('search.keyword_clusters.view_1')}
                            </button>
                            <button
                                className={`${this.props.view === 2 && 'active'}`}
                                onClick={() => this.props.onChange(2)}
                            >
                                {t('search.keyword_clusters.view_2')}
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default AdditionalBox;
